import _ from 'lodash';
import AppConstants from '../../../../config/app.constants';

class DailyBalanceSheetController {
    /*@ngInject*/
    constructor($state, $stateParams, $location, $translate, $q, User, SetupService, DateUtil, CurrencyService, BranchFundingSourceService, DailyBalanceSheetService, Modal,
                UserBranchFundingSourceService, DataCounter, $rootScope, DenominationService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.$translate = $translate;
        this.$q = $q;
        this.User = User;
        this.SetupService = SetupService;
        this.DateUtil = DateUtil;
        this.CurrencyService = CurrencyService;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.DailyBalanceSheetService = DailyBalanceSheetService;
        this.UserBranchFundingSourceService = UserBranchFundingSourceService;
        this.Modal = Modal;
        this.DenominationService = DenominationService;
        this.denominationAllType = [];
        this.balanceSheetData = '';
        this.currency = '';
        this.total = 0;
        this.isError = true;
        this.DataCounter = DataCounter;
        this.$rootScope = $rootScope;
        this.model = {
            stats: 'regular',
            branchId: User.getUser().branchId,
            date: null,
            fundingSourceId: null,
            currency: null,
            loggedInUserId: User.getUser().id
        }
        
        this.allCurrency = [];
        this.filteredCurrency = [];

        this.stats = {
            regular: 'regular',
            emergency: 'emergency'
        }
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/daily-balance-sheet');
    }

    setCurrencySymbol(currencyId) {
        if (!currencyId || !this.allCurrency || !this.allCurrency.length) {
            this.currency = '$';
            return;
        }

        const selectedCurrency = this.allCurrency.find(c => c.id === currencyId);
        this.currency = selectedCurrency && selectedCurrency.symbol ? selectedCurrency.symbol : '$';
    }

    $onInit() {
        this.dataObj = this.DataCounter.getData();

        this.$q.all([
            this.SetupService.get(this.model.branchId),
            this.CurrencyService.all(null, 0, 100),
            this.DailyBalanceSheetService.getEarliestVaultDate(this.model.branchId),
            this.DenominationService.all(null, 0, 1000)
        ])
            .then((data) => {
                if (this.dataObj && this.dataObj.isRedirected) {
                    this.model.date = this.DateUtil.convertToDate(this.dataObj.vaultDate);
                    this.currentVaultDate = moment(this.model.date).format('YYYY-MM-DD');
                }
                else {
                    this.model.date = this.DateUtil.convertToDate(data[0].currentVaultDate);
                    this.currentVaultDate = moment(this.model.date).format('YYYY-MM-DD');
                }
                if (data[2] && data[2].earliestVaultDate) {
                    this.minVaultDate = {
                        minDate: data[2].earliestVaultDate
                    }
                }
                this.allCurrency = data[1].results.filter((obj)=> data[0].availableCurrencyIds && data[0].availableCurrencyIds.includes(obj.id));
                this.branchTimezone = data[0].timezone;
                this.denominationAllType = data[3].results;
            })
            .then(() => {
                this.getBranchFundingSource('', 0)
                    .then(() => {
                        if (this.locationLists.length === 1) {
                            this.model.fundingSourceId = this.locationLists[0];
                            this.filterCurrenciesByBFS();
                            this.vaultBalance();
                        }
                        else {
                            this.autoLoadDVBHistory();
                        }
                    })
            })
            .catch((err) => {
                console.log(err);
            })
    }

    tabSelection(selectedValue) {
        this.model.stats = selectedValue;
        this.vaultBalance();
    }

    // BranchFundingSource search obj
    branchFundingSourceObj(searchKey) {
        searchKey = searchKey || '';
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: "id",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "sourceName",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                }
                            ],
                            operator: "OR"
                        }
                    }
                ],
                operator: "AND"
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    mappingBranchFundingSource(locations) {
        return locations.map((location) => {
            return {
                Key: location.id + " | " + location.sourceName,
                Value: location.id,
                manualDeposit: location.manualDeposit,
                dataObj: location
            }
        });
    }

    // Load branchFundingSource data
    getBranchFundingSource(searchKey, offset) {
        // const loadLocationData = this.branchFundingSourceObj(searchKey);
        return this.UserBranchFundingSourceService.getBranchFundingSource(this.model.loggedInUserId, this.model.branchId)
            .then((data) => {
                if (offset === 0) {
                    this.totalRecords = data.total;
                    this.locationLists = this.mappingBranchFundingSource(data.results);
                }
                else {
                    const locations = this.mappingBranchFundingSource(data.results);
                    this.locationLists = this.locationLists.concat(locations);
                }
            })
    }

    // Print Manifest of daily balance sheet
    printManifest() {
        let obj = {
            data: this.balanceSheetData,
            currency: this.currency,
            currencyId: this.model.currency,
            branch: this.model.branchId,
            vaultDate: moment(this.model.date).format('MM/DD/YYYY'),
            manualDeposit: this.model.fundingSourceId.manualDeposit
        }
        let new_path = this.$state.href('printDailyBalanceSheet');
        window.w = window.open(new_path, '_blank');
        window.w.printData = obj;
    }

    printManifestReport() {
        let obj = {
            data: this.balanceSheetData,
            currency: this.currency,
            currencyId: this.model.currency,
            branch: this.model.branchId,
            vaultDate: moment(this.model.date).format('MM/DD/YYYY'),
            vaultDateRaw: moment(this.model.date).format('YYYY-MM-DD'),
            manualDeposit: this.model.fundingSourceId.manualDeposit,
            fundingSourceId: this.model.fundingSourceId.Value,
            fundingSourceName: this.model.fundingSourceId.dataObj.sourceName,
            branchTimezone: this.branchTimezone
        }
        let new_path = this.$state.href('printDailyBalanceSheetReport');
        window.w = window.open(new_path, '_blank');
        window.w.printData = obj;
    }

    filterCurrenciesByBFS() {
        if (!this.model.fundingSourceId) {
            this.filteredCurrency = [];
            this.model.currency = null;
            this.currency = '';
            return;
        }
        
        const selectedBFS = this.locationLists.find(bfs => bfs.Value === this.model.fundingSourceId.Value);
        const currencyId = selectedBFS ? selectedBFS.dataObj.currencyId : null;
        
        if (currencyId) {
            this.filteredCurrency = this.allCurrency.filter(currency => currency.id === currencyId);
            if (this.filteredCurrency.length > 0) {
                this.model.currency = currencyId;
                this.setCurrencySymbol(currencyId);
            }
        } else {
            this.filteredCurrency = [];
            this.model.currency = null;
            this.currency = '';
        }
    }

    // get vault balance 
    vaultBalance() {
        this.totalLiability = 0;

        if (!this.model.fundingSourceId) {
            return;
        }

        this.model.loading = true;
        
        this.setCurrencySymbol(this.model.currency);

        let currentVaultDate = moment(this.model.date).format('YYYY-MM-DD');
        this.DailyBalanceSheetService.getVaultBalance(this.model.branchId, this.model.fundingSourceId.Value, this.model.stats, this.model.currency, currentVaultDate, 
                                                      this.model.fundingSourceId.manualDeposit)
            .then((data) => {
                this.model.loading = false;
                this.isError = false;
                this.balanceSheetData = data;
                this.totalLiability = data.totalLiability;
                this.resetFilter();
            })
            .catch((err) => {
                this.isError = true;
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal('error.' + err.data.message);
                }
            })
    }

    sheetInfo(infoFor, title) {
        let infoObject = [],
            data = {
                branchId: this.model.branchId, 
                fundingSourceId: this.model.fundingSourceId.Value, 
                currencyId: this.model.currency, 
                denominationId: null, 
                account: this.model.stats, 
                vaultDate: moment(this.model.date).format('YYYY-MM-DD'),
                infoFor: infoFor,
                manualDeposit: this.model.fundingSourceId.manualDeposit
            };

        this.balanceSheetData.shipment.map((shipment) => {
            const denom = (this.denominationAllType || []).find(d => d.id === shipment.denominationId);
            infoObject.push({
                'denominationId': shipment.denominationId,
                'value': shipment[infoFor],
                'coinFlag': shipment.coinFlag,
                'currencyId': shipment.currencyId,
                'symbol': shipment.symbol,
                'sortOrder': denom ? Number(denom.shiptype ? denom.shiptype.sortOrder : denom.sortOrder) : null,
                'faceValue': denom ? Number(denom.faceValue) : null
            });
        });

        this.Modal.balanceSheetInfo(infoObject, this.currency, this.$translate.instant(title), data, ({ modal }) => {
            modal.close();
        })
    }

    // generate vault report 
    generateVaultReport() {
        let currentVaultDate = moment(this.model.date).format('YYYY-MM-DD');
        this.DailyBalanceSheetService.vaultReport(this.model.branchId, String(this.model.fundingSourceId.Value), this.model.stats, this.model.currency, currentVaultDate, this.branchTimezone, this.currency)
            .then((data) => {
                // console.log(data)
            })
            .catch((err) => {
                console.log(err);
                return this.Modal.errorModal(err)
            })
    }

    autoLoadDVBHistory() {
        let fundingSource;
        if (this.dataObj && this.dataObj.isRedirected) {
            if (this.dataObj.fundingSourceId) {
                fundingSource = _.find(this.locationLists, { Value: this.dataObj.fundingSourceId });
            }
            this.model.fundingSourceId = {
                Key: fundingSource ? fundingSource.Key : this.locationLists[0].Key,
                Value: fundingSource ? fundingSource.Value : this.locationLists[0].Value,
                manualDeposit: fundingSource ? fundingSource.manualDeposit : this.locationLists[0].manualDeposit
            }
            this.filterCurrenciesByBFS();
            this.vaultBalance();
        }
    }

    resetFilter() {
        if (this.dataObj) {
            this.dataObj.isRedirected = false;
            this.dataObj = this.DataCounter.setData({});
        }
    }

    emailVaultBalanceReport() {
        this.isSendingReport = true;
        let currentVaultDate = moment(this.model.date).format('YYYY-MM-DD');
        this.DailyBalanceSheetService.emailVaultBalanceReport(this.model.branchId, currentVaultDate, String(this.model.fundingSourceId.Value))
            .then(() => { })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.isSendingReport = false;
            })
    }
}

export default DailyBalanceSheetController; 



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/daily_balance_sheet/daily_balance_sheet.controller.js